export { default as HomeBannerLoader } from "./HomeBannerLoader";
export { default as ProductLoading } from "./ProductLoading";
export { default as ProductSliderLoader } from "./ProductSliderLoader";
export { default as SectionLoader } from "./SectionLoader";
export { default as OrderDetailLoader } from "./OrderDetailLoader";
